/**
 * 配置审核流程(道闸)
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 待建立审核流程车辆
Mock.mock(/visits\/\d+\/exiting\/process\/start($|\??)/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'brands': [{
      'id': 7,
      'is_current_brand': false,
      'is_self_brand': true,
      'name': '丰田'
    }, {
      'id': 26,
      'is_current_brand': true,
      'is_self_brand': true,
      'name': '本田'
    }, {
      'id': 3,
      'is_current_brand': false,
      'is_self_brand': false,
      'name': '宝马'
    }],
    'exiting_rules': [],
    'comments': [{
      'comment_id': 1,
      'comment': '销售看车'
    }, {
      'comment_id': 2,
      'comment': '合作来访'
    }, {
      'comment_id': 3,
      'comment': '试乘试驾'
    }, {
      'comment_id': 4,
      'comment': '其他'
    }],
    'visit_id': 1, // 到店记录ID
    'car_id': 1, // 车辆ID
    'plate_number': '粤B12345', // 车牌
    'model_desc': '宝马X6', // 车型
    'vin': 'WDBGP57B6PB127810', // 车架号
    'exiting_rule_id': 1, // 放行规则ID
    'exiting_rule_steps': [{
      'step_id': 1, // step_id
      'step_no': 1, // 步骤编号
      'title': '步骤一', // 步骤名称
      'review_employee_choices': [{
        'employee_id': 1, // 员工ID
        'employee_name': /张五（续保员）|李八（服务顾问）/ // 员工名称
      }]
    }, {
      'step_id': 2, // step_id
      'step_no': 2, // 步骤编号
      'title': '步骤二', // 步骤名称
      'review_employee_choices|3': [{
        'employee_id|+2': 1, // 员工ID
        'employee_name': /张三（续保员）|李四（服务顾问）/ // 员工名称
      }]
    }, {
      'step_id': 3, // step_id
      'step_no': 3, // 步骤编号
      'title': '步骤三', // 步骤名称
      'review_employee_choices|3': [{
        'employee_id|+3': 1, // 员工ID
        'employee_name': /张三（续保员）|李四（服务顾问）/ // 员工名称
      }]
    }, {
      'step_id': 4, // step_id
      'step_no': 4, // 步骤编号
      'title': '步骤四', // 步骤名称
      'review_employee_choices|4': [{
        'employee_id|+4': 1, // 员工ID
        'employee_name': /张三01（续保员）|李四02（服务顾问）/ // 员工名称
      }]
    }],
    'customer_choices|3': [{
      'customer_id|+1': 1, // 客户ID
      'customer_name': /老王（13811995621）|老班（13811995621）|老还（13811995621）/ // 客户名称
    }]
  }
})

// 所有待放行车辆
Mock.mock(/visits\/\d+\/exiting\/process\/start($|\??)/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'exiting_process_id': 1, // 已发起放行流程ID
  'next_step_review_employees|4': [{
    'employee_id|+1': 1, // 员工ID
    'employee_name': /张三\(续保经理\)|李四\(续保经理\)|王五\(续保经理\)/ // 员工名称
  }]
})
